import {
  CSSTransition,
  type WithFocusLockProps,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import type {
  CustomLayerOptionsV2,
  LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import {LayerContent} from './layer-content';

type LayerBaseProps = {
  readonly active: boolean;
  readonly scrollElementRef: (el: HTMLDivElement) => void;
  readonly 'aria-labelledby'?: string;
};

export type LayerComponentProps = React.PropsWithChildren<LayerBaseProps>;

export type CustomLayerProps = LayerBaseProps & {
  readonly layer: LayerV2<unknown, CustomLayerOptionsV2>;
};

const Layer: React.FunctionComponent<CustomLayerProps> = (props) => {
  const {layer, active, scrollElementRef, ...ownProps} = props;
  const {options} = layer;

  const LayerOptionsComponent: React.ComponentType<LayerComponentProps> =
    options.layerComponent;

  return (
    <CSSTransition
      {
        ...ownProps /* Used to pass through the animation props */
      }
      classNames={options.animationClassNames}
      timeout={options.animationTimeout}
    >
      <LayerOptionsComponent
        active={active}
        aria-labelledby={layer.options['aria-labelledby']}
        scrollElementRef={scrollElementRef}
      >
        <LayerContent layer={layer} />
      </LayerOptionsComponent>
    </CSSTransition>
  );
};

const CustomLayerWithLock = withFocusLock<CustomLayerProps>(Layer);
CustomLayerWithLock.displayName = 'CustomLayerWithLock';

export const CustomLayer: React.ElementType = (
  props: CustomLayerProps & WithFocusLockProps,
) => {
  return <CustomLayerWithLock {...props} disabled={props.layer.isClosed} />;
};
